import React from "react"
import classNames from "classnames"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"

import { setForm } from "../../../../redux/slices/signupSlice"
import { SubscriptionButton } from "../../../common"
import { FormattedMessage, useIntl } from "react-intl"

import { formatPrice } from "../../../../util/format"

import { TALK_TO_US_URL, TOKEN_PRICE, TOKENS_AMOUNT_TO_ADD } from "../../../../constants"

const BillingOptions = ({
  idealBillingOption,
  onSelect,
  loading,
  setValue,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { formatMessage } = useIntl()

  const billingOptions = [
    {
      title: formatMessage({ id: "common.premium" }),
      texts: [
        {
          label: formatMessage({ id: "common.payAsYouGo" }),
          highlight: true,
          bold: true,
        },
        {
          label: formatMessage({ id: "message.noCommitmentAddMoreWhenNeeded" }),
        },
        {
          label: "",
          bold: true,
        },
        {
          label: formatMessage({ id: "common.startingFrom" }),
          bold: true,
        },
        {
          label: `${formatPrice(TOKENS_AMOUNT_TO_ADD.MIN * TOKEN_PRICE, 0)} €`,
          bold: true,
          highlight: true,
          large: true,
        },
        {
          label: `per ${TOKENS_AMOUNT_TO_ADD.MIN} Tokens`,
          bold: true,
        },
      ],
      button: formatMessage({ id: "choosePricing.button.continue" }),
      type: "PayAsYouGo",
    },
    // {
    //   title: "Subscription",
    //   texts: [
    //     {
    //       label: formatMessage({ id: "message.twelveMonthSubscription" }),
    //       highlight: false,
    //     },
    //     {
    //       label: `${formatMessage({ id: "message.saveUpTo40Percent" })}${
    //         isFreemium
    //           ? ""
    //           : ", " + formatMessage({ id: "message.andFirstWeekFree" })
    //       }`,
    //       highlight: true,
    //       bold: true,
    //     },
    //     {
    //       label: formatMessage({
    //         id: "message.analyzeFrom100To500CVsPerMonth",
    //       }),
    //       highlight: false,
    //     },
    //     {
    //       label: formatMessage({ id: "message.matchUpTo4JobsPerMonth" }),
    //       highlight: false,
    //     },
    //   ],
    //   button: formatMessage({ id: "common.chooseSubscription" }),
    //   type: "Subscription",
    // },
    {
      title: formatMessage({ id: "common.enterprise" }),
      texts: [
        {
          label: formatMessage({
            id: "message.forLargerCompaniesMakingMoreThan100HiresPerYear",
          }),
        },
        {
          label: formatMessage({
            id: "choosePricing.planDescription.noHiresPlan",
          }),
          bold: true,
        },
        {
          label: formatMessage({
            id: "choosePricing.planDescription.talkToUs",
          }),
        },
        {
          label: formatMessage({
            id: "common.veryLowCostPerHire",
          }),
          highlight: true,
          bold: true,
        },
      ],
      button: formatMessage({ id: "common.getAQuote" }),
      buttonLink: TALK_TO_US_URL,
      type: "Enterprise",
    },
  ]

  const onClick = (item) => {
    dispatch(setForm({ name: "subscriptionType", value: item.type }))
    onSelect()

    if (item.buttonLink) {
      return navigate(item.buttonLink)
    }
  }

  return (
    <div className="billing-options">
      {billingOptions.map((billingOption) => (
        <div className="billing-option">
          {idealBillingOption === billingOption.type && (
            <div className="billing-option__ideal">
              <FormattedMessage id="common.idealForYourCompany" />
            </div>
          )}

          <p className="billing-option__title">{billingOption.title}</p>
          <div className="billing-option__texts">
            {billingOption.texts.map((text) => (
              <p
                className={classNames(`billing-option__text`, {
                  "billing-option__text--highlight": text.highlight,
                  "billing-option__text--bold": text.bold,
                  "billing-option__text--large": text.large,
                })}
              >
                {text.label}
              </p>
            ))}
          </div>

          <SubscriptionButton
            onClick={() => onClick(billingOption)}
            text={billingOption.button}
            isIdeal={
              billingOption.isIdeal || idealBillingOption === billingOption.type
            }
            loading={loading}
          />
        </div>
      ))}
    </div>
  )
}

export default BillingOptions
